import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import VuiBox from "components/ui/VuiBox";
import LayoutContext from "context/LayoutContext";
import { useUIController, setLayout } from "context";

function DashboardLayout({ children, navbarHeight }) {
  const [controller, dispatch] = useUIController();
  const { miniSidenav } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname, dispatch]);

  const padding = {
    p: 3,
  };

  return (
    <LayoutContext.Provider value={padding}>
    <VuiBox
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        ...padding,
        position: "relative",
        paddingTop: pxToRem(navbarHeight ?? 90),
        height: "100%",

        [breakpoints.down("lg")]: {
          paddingTop: pxToRem(navbarHeight ? navbarHeight + 8 : 108),
        },

        [breakpoints.up("md")]: {
          marginLeft: miniSidenav ? pxToRem(120) : pxToRem(274),
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      })}
    >
      {children}
    </VuiBox>
    </LayoutContext.Provider>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
  navbarHeight: PropTypes.number,
};

export default DashboardLayout;
